import { TextureData } from "../../../types/types";
import { ISize } from "../../../controls/scrollpane/ISize";
import { RectSize } from "../../../utils/RectSize";
import { SettingsItem } from "../options/SettingsItem";
import { AppSettings } from "../../managers/AppSettings";
import { Padding } from "../../../utils/Padding";
import { LayoutDataManager } from "../../managers/LayoutDataManager";
import { LoaderFileKeys } from "../../constant/AppConstants";

export enum ResultsListItemBubbleColor {
    GREEN = AppSettings.colors.green,
    RED = AppSettings.colors.red,
    // deuce
    // YELLOW = AppSettings.colors.yellow,
    ORANGE = AppSettings.colors.orange,
}

export type ResultsListItemData = {
    // label text?
    label?: string;
    // icon?
    icon?: TextureData;
    // background rect? undefined==none
    bubbleColor?: ResultsListItemBubbleColor;
}

/**
 * NOTE: dynamic part of setData for item2 and item3 can either display:
 * - text (any item except trump)
 * - text (NT|AT) OR icon (diamond|heart|spade|clubs)
 *   ^ AND THIS CAN CHANGE FROM DEAL TO DEAL
 */
export class ResultsListItem
    extends SettingsItem
    implements ISize {
    public item2_bubble: Phaser.GameObjects.Image;
    public item3_bubble: Phaser.GameObjects.Image;
    public item2_label: Phaser.GameObjects.Text;
    public item3_label: Phaser.GameObjects.Text;
    public item2_icon: Phaser.GameObjects.Image;
    public item3_icon: Phaser.GameObjects.Image;

    protected bgTextureData: TextureData;
    protected labelTextStyle: Phaser.Types.GameObjects.Text.TextStyle;
    protected bubblePadding: Padding = new Padding(10, 15);
    protected bubbleWidth: number;
    protected item1Data: string;
    protected item2Data: ResultsListItemData;
    protected item3Data: ResultsListItemData;

    // delimiter line
    public imgDelimiterLine: Phaser.GameObjects.Image;
    protected hasDelimiterLine: boolean;
    protected delimiterLineAlpha: number;


    public Init(
        bgTextureData: TextureData = undefined,
        labelTextStyle: Phaser.Types.GameObjects.Text.TextStyle = undefined,
        delimiterLineAlpha: number,
    ): void {
        this.bgTextureData = bgTextureData;
        this.labelTextStyle = labelTextStyle;
        this.delimiterLineAlpha = delimiterLineAlpha;

        this.size = new RectSize();
    }

    public Build(): void {
        this.bg = this.scene.make.image({ key: this.bgTextureData.texture, frame: this.bgTextureData.frame });
        this.bg.setOrigin(0);
        this.add(this.bg);

        this.item2_bubble = this.scene.make.image({ key: LoaderFileKeys.ui, frame: "rect-rounded-green.png" });
        this.add(this.item2_bubble);

        this.item3_bubble = this.scene.make.image({ key: LoaderFileKeys.ui, frame: "rect-rounded-green.png" });
        this.add(this.item3_bubble);

        this.bubbleWidth = this.item2_bubble.displayWidth;

        this.label = this.scene.make.text({ style: this.labelTextStyle });
        this.label.setOrigin(0, 0.5);
        this.add(this.label);

        this.item2_icon = this.scene.make.image({});
        this.item2_icon.setOrigin(0.5);
        // this.item2_icon.setScale(0.7);
        this.add(this.item2_icon);

        this.item2_label = this.scene.make.text({ style: this.labelTextStyle });
        this.item2_label.setOrigin(0.5);
        this.add(this.item2_label);

        this.item3_icon = this.scene.make.image({});
        // this.item3_icon.setOrigin(1, 0.5);
        this.item3_icon.setOrigin(0.5); // override TP defaults
        // this.item3_icon.setScale(0.7);
        this.add(this.item3_icon);

        this.item3_label = this.scene.make.text({ style: this.labelTextStyle });
        this.item3_label.setOrigin(0.5);
        // this.item3_label.setOrigin(1, 0.5);
        this.add(this.item3_label);

        this.imgDelimiterLine = this.scene.make.image({ key: LoaderFileKeys.ui, frame: "rect-2x2-white.png" });
        this.imgDelimiterLine.setOrigin(0, 0.5);
        this.imgDelimiterLine.alpha = this.delimiterLineAlpha;
        this.add(this.imgDelimiterLine);
    }

    public SetData(
        item1_data: string = undefined,
        item2_data: ResultsListItemData = undefined,
        item3_data: ResultsListItemData = undefined,
        hasDelimiterLine: boolean,
    ): void {
        // console.log("ResultsListItem::SetData",item1_data,item2_data,item3_data);

        // NOTE: when refreshing visibility, use alpha, coz visible is used for smartCull, or SmartCull will (not so smartly) expose teh underlying unloaded texture
        // EDIT: or use alpha for SmartCull and visible here.
        this.hasDelimiterLine = hasDelimiterLine;
        this.imgDelimiterLine.visible = hasDelimiterLine;

        // item1_data text
        if (item1_data != undefined) {
            this.label.text = item1_data;
        }

        // if item2_data supplied
        if (item2_data != undefined) {
            // item2_data label Text
            if (item2_data.label != undefined) {
                this.item2_label.text = item2_data.label;
                this.item2_label.visible = true;
            }
            else {
                this.item2_label.visible = false;
            }

            // item2_data icon TextureData
            if (item2_data.icon != undefined) {
                this.item2_icon.setTexture(item2_data.icon.texture, item2_data.icon.frame);
                this.item2_icon.visible = true;
            }
            else {
                this.item2_icon.visible = false;
            }

            // item2_data bubble color for bubble bg Graphics
            if (item2_data.bubbleColor != undefined) {
                this.SetBubbleFrame(this.item2_bubble, item2_data.bubbleColor);
                this.item2_bubble.visible = true;
            }
            else {
                this.item2_bubble.visible = false;
            }
        }
        // if item3_data supplied
        if (item3_data != undefined) {
            // item3_data label Text
            if (item3_data.label != undefined) {
                this.item3_label.text = item3_data.label;
                // this.item3_label.setOrigin(item3_data.bubbleColor == undefined ? 1 : 0.5, 0.5);
                this.item3_label.visible = true;
            }
            else {
                this.item3_label.visible = false;
            }
            // item3_data icon TextureData
            if (item3_data.icon != undefined) {
                this.item3_icon.setTexture(item3_data.icon.texture, item3_data.icon.frame);
                this.item3_icon.setOrigin(0.5);
                this.item3_icon.visible = true;
            }
            else {
                this.item3_icon.visible = false;
            }
            // item3_data bubble color for bubble bg Graphics
            if (item3_data.bubbleColor != undefined) {
                this.SetBubbleFrame(this.item3_bubble, item3_data.bubbleColor);
                this.item3_bubble.visible = true;
            }
            else {
                this.item3_bubble.visible = false;
            }
        }
    }

    private SetBubbleFrame(bubble: Phaser.GameObjects.Image, color: ResultsListItemBubbleColor): void {
        switch (color) {
            case ResultsListItemBubbleColor.GREEN:
                bubble.setFrame("rect-rounded-green.png");
                bubble.visible = true;
                break;
            case ResultsListItemBubbleColor.ORANGE:
                bubble.setFrame("rect-rounded-orange.png");
                bubble.visible = true;
                break;
            case ResultsListItemBubbleColor.RED:
                bubble.setFrame("rect-rounded-red.png");
                bubble.visible = true;
                break;
            default:
                bubble.visible = false;
                break;

        }
    }

    /**
     * @alike: OnResize
     * 
     * Calls SetSize (on SettingsItem from parent->DealCompleteResultsContent->ScrollPaneTotledListContent), 
     * which calls this.OnResize
     * 
     * Uses 'maximum allowed width' to compute item's resulting height
     * - Item's width and height depends on height of label textfield
     * - label's height depends on amount of HORIZONTAL space and maximum horizontal space allowed for item
     * 
     * @param width 
     */
    public override SetWidthGetHeight(width: number): number {
        // console.log("SetWidthGetHeight");

        const spacePerElement = width / 3;
        // const spacePerElement = (width / this.innerScale)/3; // unscaled, since the element is already scaled
        this.label.style.setWordWrapWidth(spacePerElement);

        // perfect vertical size for each item based on conntet?
        // return Math.max(
        //     // single leading label (left most)
        //     this.label.displayHeight,
        //     // possibly icons of different height
        //     this.item2_icon.visible ? this.item2_icon.displayHeight : 0,
        //     this.item3_icon.visible ? this.item3_icon.displayHeight : 0,
        //     // all bubbles are same height
        //     this.item2_bubble.visible ? this.item2_bubble.displayHeight : 0,
        // ) + 2 * this.borderPadding.vertical;

        // computes and returns height
        return this.label.displayHeight + 2 * this.borderPadding.vertical;
    }

    public override OnResize(): void {
        // console.log("ResultsItem::OnResize");

        this.bg.setDisplaySize(this.size.width, this.size.height);

        // delimiter (if item has it -- last item in list does not have it)
        if (this.hasDelimiterLine) {
            // origin 0,1 (bot left)
            this.imgDelimiterLine.y = this.size.height;
            this.imgDelimiterLine.displayWidth = this.size.width;
        }

        // label origin (0, 0.5)
        this.label.setPosition(this.borderPadding.horizontal, this.size.height / 2);

        const item2PosX = this.size.width / 2;
        const item2PosY = this.size.height / 2;
        this.item2_label.setPosition(item2PosX, item2PosY);
        this.item2_icon.setPosition(item2PosX, item2PosY);
        this.item2_bubble.setPosition(item2PosX, item2PosY);

        const item3PosX = this.size.width - this.borderPadding.horizontal - this.bubbleWidth * 0.5;
        const item3PosY = this.size.height * 0.5;
        this.item3_label.setPosition(item3PosX, item3PosY);
        this.item3_icon.setPosition(item3PosX, item3PosY);
        this.item3_bubble.setPosition(item3PosX, item3PosY);
    }
}